import { useAtom, useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { PossibleConfiguratorOptionValues } from '~/app/models/configurator-options';
import { state } from '~/storage';

// Returns the current step and total steps based on the current combination

export const useSteps = (combination: PossibleConfiguratorOptionValues) => {
	const combinations = useAtomValue(state.configuredCombinationsAtom);
	const [hiddenSteps] = useAtom(state.hiddenConfiSteps);

	const filteredSteps = useMemo(() => {
		if (!combinations || !hiddenSteps) return [];
		return combinations?.filter((item) => !hiddenSteps[item]);
	}, [JSON.stringify(combinations), hiddenSteps]);

	const total = useMemo(() => {
		if (!combinations || !hiddenSteps) return 0;

		return combinations?.length - Object.values(hiddenSteps).filter(Boolean).length;
	}, [JSON.stringify(combinations), hiddenSteps]);

	const step = useMemo(() => {
		if (!hiddenSteps) return 0;
		return filteredSteps?.indexOf(combination) + 1;
	}, [filteredSteps, combination]);

	return { step, total };
};
